// Pon esto en true para mostrar "web en mantenimiento" al público y en
// false para abrir la web normal a todo el mundo. Hay que hacer un nuevo
// `npm run build` y subirlo para que el cambio se note.
export const MODO_MANTENIMIENTO = true;

// Palabra secreta para saltarse la pantalla de mantenimiento: mientras esté
// activo, escribid esto con el teclado (no hace falta hacer clic en nada
// antes) y se desbloquea. Queda guardado en ese navegador, así que no hay
// que repetirlo cada vez.
export const PALABRA_SECRETA = "ceuti";
